import {
    Routes,
    Route, BrowserRouter,
} from "react-router-dom";
import React, { Suspense } from "react";
import Loader from "../Components/Loader";
import MatLayout from "../Components/matLayout";
function Plan() {
    const EditProfile = React.lazy(() => import("../Components/editProfile/editProfile"))
    const Ticket = React.lazy(() => import("../Components/ticket/tickets"))
    const CreateTicket = React.lazy(() => import("../Components/ticket/createTicket"))
    const TicketDetail = React.lazy(() => import("../Components/ticket/ticketDetail"))
    const Plans = React.lazy(() => import("../Components/plan/plans"))
    const Home = React.lazy(() => import("../Components/plan/home"))
    const Payment = React.lazy(() => import("../Components/plan/payment"))
    const ListPayment = React.lazy(() => import("../Components/plan/listPayment"))
    const ListUserPlans = React.lazy(() => import("../Components/plan/listUserPlans"))
    const Service = React.lazy(() => import("../Components/service"))
    const PaymentVerify = React.lazy(() => import("../Components/paymentVerify"))
    const FaqCategory = React.lazy(() => import("../Components/faqCategory"))
    
    return (
        <MatLayout>
            <Routes>
                <Route path="edit-profile" element={<EditProfile />} />
                <Route path="tickets" element={<Ticket />} />
                <Route path="tickets/create" element={<CreateTicket />} />
                <Route path="tickets/:id" element={<TicketDetail />} />
                <Route path="" element={<Home />} />
                <Route path="plans" element={<Plans />} />
                <Route path="plan-order/:id" element={<Payment />} />
                <Route path="my-payments" element={<ListPayment />} />
                <Route path="my-plans" element={<ListUserPlans />} />
                <Route path="service" element={<Service />} />
                <Route path="payment-verify" element={<PaymentVerify />} />
                <Route path="faq" element={<FaqCategory />} />
            </Routes>
        </MatLayout>
    )
}
export default function RouteComponent() {

    const Login = React.lazy(() => import("../Components/accounts/login"))

    return (
        <>
            <Suspense fallback={<Loader />}>
                <Routes>
                    <Route path="support/login" element={<Login />} />
                    <Route path="support/*" element={<Plan />} />
                </Routes>
            </Suspense>
        </>
    );
}
